/**
 * Priorités de conception (champ `cases.priority`).
 * Nouvelles valeurs : normal, express, urgente.
 * Les anciennes (low, medium, high, urgent) restent affichables pour les dossiers existants.
 */

export const CASE_PRIORITY_FORM_OPTIONS = [
  { value: 'normal', label: 'Normal' },
  { value: 'express', label: 'Express' },
  { value: 'urgente', label: 'Urgente' },
];

const LEGACY_PRIORITY_OPTIONS = [
  { value: 'low', label: 'Basse (ancienne)' },
  { value: 'medium', label: 'Moyenne (ancienne)' },
  { value: 'high', label: 'Haute (ancienne)' },
  { value: 'urgent', label: 'Urgente / urgent (ancienne)' },
];

/**
 * Options pour un &lt;Select&gt; : liste courante + ancienne valeur si le dossier ne l’a pas encore migrée.
 */
export function getCasePrioritySelectOptions(currentPriority) {
  const values = new Set(CASE_PRIORITY_FORM_OPTIONS.map((o) => o.value));
  if (currentPriority != null && values.has(currentPriority)) {
    return CASE_PRIORITY_FORM_OPTIONS;
  }
  const legacy = LEGACY_PRIORITY_OPTIONS.find((o) => o.value === currentPriority);
  return legacy ? [legacy, ...CASE_PRIORITY_FORM_OPTIONS] : CASE_PRIORITY_FORM_OPTIONS;
}

export const CASE_PRIORITY_LABELS = {
  normal: 'Normal',
  express: 'Express',
  urgente: 'Urgente',
  low: 'Basse',
  medium: 'Moyenne',
  high: 'Haute',
  urgent: 'Urgente',
};

export function getCasePriorityLabel(priority) {
  if (priority == null || priority === '') return '';
  return CASE_PRIORITY_LABELS[priority] ?? priority;
}

/** Pour filtres tableau de bord / compteurs « prioritaires » (nouveau + ancien schéma). */
export const ELEVATED_CASE_PRIORITIES = ['urgente', 'urgent', 'express', 'high'];

/** Priorité dossier → enum `production_batches.priority` (`low`|`medium`|`high`|`urgent`). */
export function mapCasePriorityToBatchPriority(casePriority) {
  const m = {
    normal: 'medium',
    express: 'high',
    urgente: 'urgent',
    low: 'low',
    medium: 'medium',
    high: 'high',
    urgent: 'urgent',
  };
  return m[casePriority] ?? 'medium';
}
